import { useState } from "react";

import { Outlet } from "react-router-dom";

import {
  AdjustmentsHorizontalIcon,
  ArrowsRightLeftIcon,
  ChartBarIcon,
  ChatBubbleLeftRightIcon,
  ComputerDesktopIcon,
  CurrencyPoundIcon,
  Cog6ToothIcon,
  DocumentTextIcon,
  GlobeAltIcon,
  InboxStackIcon,
  LightBulbIcon,
  PencilSquareIcon,
  QuestionMarkCircleIcon,
  RocketLaunchIcon,
  ShoppingBagIcon,
  SparklesIcon,
  Squares2X2Icon,
  TagIcon,
  TruckIcon,
  UserGroupIcon,
  WrenchScrewdriverIcon,
} from "@heroicons/react/24/outline";

import Topbar from "../components/shared/Navbar/Topbar";
import { INavigationItem } from "../types/Navigation";
import { usePageNameContext } from "../contexts/PageTitleContext";
import MobileSidebar from "../components/shared/Navbar/MobileSidebar";
import DesktopSidebar from "../components/shared/Navbar/DesktopSidebar";

const navigation: INavigationItem[] = [
  { name: "Dashboard"      , to: "/"            , icon: Squares2X2Icon },
  { name: "Customers"      , to: "customers"    , icon: UserGroupIcon },
  { name: "Applications"   , to: "applications" , icon: ComputerDesktopIcon },
  { name: "Category Editor", to: "categories"   , icon: TagIcon },
  { name: "Pending Categories", to: "pending-categories", icon: InboxStackIcon },
  { name: "Pinnacle Mapping", to: "pinnacle-mapping", icon: ArrowsRightLeftIcon },
  { name: "Title Configuration", to: "title-configuration", icon: PencilSquareIcon },
  { name: "Initial Price Estimate", to: "initial-price-estimate", icon: CurrencyPoundIcon },
  { name: "Features"       , to: "features"     , icon: Cog6ToothIcon },
  { name: "Templates"      , to: "templates"    , icon: DocumentTextIcon },
  { name: "Settings"       , to: "settings"     , icon: AdjustmentsHorizontalIcon },
  { name: "Scrape Data"    , to: "scrape"       , icon: GlobeAltIcon },
  { name: "Seller History" , to: "scrape/seller-history", icon: ShoppingBagIcon },
  { name: "Tools"          , to: "tools"        , icon: WrenchScrewdriverIcon },
  { name: "Deployments"    , to: "deployments"  , icon: RocketLaunchIcon },
  { name: "Amazon MVL"     , to: "mvl"          , icon: TruckIcon },
  { name: "AI Review"      , to: "scrape/ai-review", icon: SparklesIcon },
  { name: "Reports"        , to: "reports"      , icon: ChartBarIcon },
  { name: "Tickets"        , to: "tickets"      , icon: ChatBubbleLeftRightIcon },
  { name: "Ticket Insights", to: "tickets/insights", icon: LightBulbIcon },
  // { name: "Missing Page", to: "missing", icon: QuestionMarkCircleIcon }, // This page doesn't exist; here to test your error page
];

export default function Layout() {
  const {
    pageInfo: { name, desc },
  } = usePageNameContext();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="h-full">
      <MobileSidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        navigation={navigation}
      />
      <DesktopSidebar navigation={navigation} />
      <div className="min-h-screen h-full flex flex-1 flex-col md:pl-64">
        <Topbar setSidebarOpen={setSidebarOpen} />
        <main className="h-full bg-gray-100">
          <div className="mx-4 mt-4 mb-2 md:mx-6 md:mt-6 md:mb-3">
            <h1 className="text-3xl font-stick font-bold">{name}</h1>
            <h4 className="font-l font-semibold text-gray-600 mt-1">{desc}</h4>
          </div>
          <div className="mx-4 mb-4 md:mx-6 md:mt-2">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
